/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskBoxPersonResponse
 */
export interface TaskBoxPersonResponse {
    /**
     * 
     * @type {string}
     * @memberof TaskBoxPersonResponse
     */
    personWithRoleId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskBoxPersonResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskBoxPersonResponse
     */
    lastName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskBoxPersonResponse
     */
    isAssignee?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskBoxPersonResponse
     */
    isCreator?: boolean;
}

/**
 * Check if a given object implements the TaskBoxPersonResponse interface.
 */
export function instanceOfTaskBoxPersonResponse(value: object): value is TaskBoxPersonResponse {
    return true;
}

export function TaskBoxPersonResponseFromJSON(json: any): TaskBoxPersonResponse {
    return TaskBoxPersonResponseFromJSONTyped(json, false);
}

export function TaskBoxPersonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskBoxPersonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'personWithRoleId': json['personWithRoleId'] == null ? undefined : json['personWithRoleId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'isAssignee': json['isAssignee'] == null ? undefined : json['isAssignee'],
        'isCreator': json['isCreator'] == null ? undefined : json['isCreator'],
    };
}

export function TaskBoxPersonResponseToJSON(json: any): TaskBoxPersonResponse {
    return TaskBoxPersonResponseToJSONTyped(json, false);
}

export function TaskBoxPersonResponseToJSONTyped(value?: TaskBoxPersonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personWithRoleId': value['personWithRoleId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'isAssignee': value['isAssignee'],
        'isCreator': value['isCreator'],
    };
}

